import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';

import styles from './styles.scss';

const Achievements = ({ achievements }) => {
  if (achievements.length === 0) {
    return null;
  }

  return (
    <div
      className={`section athlete-achievements ${styles.athleteAchievements}`}
    >
      <h3>{I18n.t('strava.athletes.show_public.recent_achievements')}</h3>
      <ul>
        {achievements.map(
          ({ showTrophy, spriteName, description, timeago }) => (
            <li>
              {showTrophy ? (
                <div
                  className={`app-icon icon-lg ${styles.appIcon} ${spriteName}`}
                />
              ) : null}
              <div className={styles.description}>
                <div className={styles.title}>{description}</div>
                <div
                  className={styles.timestamp}
                  dangerouslySetInnerHTML={{ __html: timeago }}
                />
              </div>
            </li>
          )
        )}
      </ul>
    </div>
  );
};

Achievements.propTypes = {
  achievements: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Achievements;
